import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import "@/common/css/normalize.css"
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import http from "./http/index"
import common from "./common/js/common"
import pinia from "./store"
import '@/common/css/wickedcss.min.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import Vant from "vant";
// 2. 引入组件样式
import 'vant/lib/index.css';
//Naive UI
import naive from 'naive-ui'

// px->rem
//import "amfe-flexible";
// import '@/utils/rem.js'

import Plugin from 'v-fit-columns';

import likeUI from './components/index';

const app = createApp(App);
app.use(naive);
app.config.globalProperties.$http = http;
app.config.globalProperties.$common = common;
app.config.globalProperties.$uploadImgUrl = process.env.VUE_APP_BASE_API + "tools/sign_upload";
app.config.globalProperties.$uploadImgUrlAlias = process.env.VUE_APP_BASE_API + "/common/upload/file";


const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
    }
}

// app.use(store);
app.use(router);
app.use(ElementPlus, {locale: zhCn});
app.use(Plugin);
app.use(likeUI);
app.use(pinia);
app.use(Antd);
app.use(Vant);
app.mount('#app');
